export default __webpack_public_path__ + "static/media/illustration-product-design.4918012a.svg";